import React, {useState, useEffect, useLayoutEffect} from 'react'
import { Box, Alert, Button, IconButton, Typography } from '@mui/material'
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import InputComponent from './../components/Common/InputComponent';
// import { linkBaseUrl } from './../utils/userRequest'
import { useDispatch, useSelector } from 'react-redux';
import { Link, Navigate, useNavigate } from 'react-router-dom';
// import { loginAction } from '../redux/actions/userAction';
import { useForm } from 'react-hook-form';
import { googleLoginAction, loginAction, profileUpdateAction } from '../redux/actions/capitalAction';
import { getBaseLink, userAuth } from '../constants/helpers';
import { LOGO } from '../images/images';

// import { GoogleLogin, GoogleLogout } from 'react-google-login';

// import { gapi } from 'gapi-script'; 
import { googleApiRequest } from '../utils/capitalRequest';
import { GoogleLogin } from '@react-oauth/google';
import jwt_decode from "jwt-decode";



const LoginPageUser = () => {

  
  const dispatch = useDispatch();
  const { data, loading, error, msg, isLoggedIn, isAuthenticated } = useSelector((state) => state.loginData);
  const { data:dataGoogle, loading:loadingGoogle, error:errorGoogle, msg:msgGoogle } = useSelector((state) => state.googleLoginReducer);
  const { data:profileUpdateData, loading:profileUpdateLoading, isUpdated } = useSelector((state) => state.profileUpdateReducer);




  const navigation = useNavigate();
  const [showPassword, setShowPassword] = React.useState(false);
  const [inputs, setInputs] = React.useState({});
  const [errors, setErrors] = React.useState({});

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  
  const handleChangeInput = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs({...inputs, [name]: value});
  }
  

const { control, handleSubmit, register, reset } = useForm({
    defaultValues: {
        username: "",
        password: "",
        mobile: "",
    }
})


const [ profile, setProfile ] = React.useState([]);


const [ UserProfileData, setUserProfileData ] = React.useState(null);
const clientId = '956936008951-lb9c7igeouria747k1a13gd7jdd1mcdm.apps.googleusercontent.com';


React.useEffect(() => {
  if(!loadingGoogle){
    console.log(dataGoogle)
    if(dataGoogle.data && dataGoogle.data?.user?.type_r0 !== "1"){
      window.location.replace(`${getBaseLink()}`)
    }
  }
}, [dispatch, loadingGoogle]);

const onSuccess = async (res) => {

  // console.log('res >>> ', res);
  var credential = jwt_decode(res.credential);
  // console.log('credential >>>> ', credential);

  // return ;

  const params = {
    "email":credential?.email,
    "name":credential?.name,
    "google_id":credential?.google_id,
  }

  if(!loadingGoogle){
    if(dataGoogle.data && dataGoogle.data?.user?.type_r0 !== "1"){
      // window.location.replace(`${getBaseLink()}`)
    }
  }else{

    dispatch(googleLoginAction(params))
    setProfile(credential);
  }

    
};

const onFailure = (err) => {
    console.log('failed', err);
};

const logOut = () => {
    setProfile(null);
};



// const onSubmit = (data) => {
  
//   dispatch(loginAction(data.username, data.password))
  
// };


const onSubmitUpdate = (data) => {

  const params = {
    "first_name": data?.first_name,
    "last_name": data?.last_name,
    "email": profile.email,
    "mobile": data?.mobile,
  }
  
  dispatch(profileUpdateAction(params))
  
};


useEffect(() => {
  if(isUpdated){
    window.location.replace(`${getBaseLink()}`)
  }
}, [dispatch, profileUpdateLoading, isUpdated])


useEffect(() => {
  
  var rootSection = window.location.href.split('/')[3];
  
  // console.log('sasa', loading);

  // if(userAuth() === true){
  //   navigation('/admin')
  // }

  if(isAuthenticated){
    // navigation('/admin');
  }
  
  if(!loading){
    if(localStorage.getItem('user')){
      const uData = JSON.parse(localStorage.getItem('user'));

      if(rootSection === "price"){
        
        // navigation('/list');
      }
      else
      if(rootSection === "calendar"){
        
        // navigation('/assign');
      }
      else
      {
      }
      window.location.replace(`${getBaseLink()}`)
    }
  }
}, [dispatch, loading])



  return (
    <>

      <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundImage:'url(https://asascapital.com/wp-content/uploads/2022/01/Herobesy.jpg)', backgroundPosition: "bottom", backgroundSize:"bottom" }}>
        <div className='form' style={{ backgroundColor:'#ffffffb8' }}>
          <div className='form_logo' style={{ 
            padding: '4px 0.5rem', margin: '0 auto', display: 'grid', borderRadius: '5px'
           }}>
            {/* Lo<span>g</span>o */}
            <img src={LOGO} style={{ width: '13rem' }} />
          </div>
          <div className="w-100">
            {
              error ?
                <Alert fullWidth variant="outlined" severity="error">
                  {error}
                </Alert>
                :
                null
            }
            {
              msg ?
                <Alert fullWidth variant="outlined" severity="error">
                  {msg}
                </Alert>
                :
                null
            }
            
          </div>

          
            {
              dataGoogle.data && dataGoogle.data?.user?.type_r0 === "1" ?
              <>
              <br />
              <h2>Profile Update</h2>
              <form method='post' className='form_items'  onSubmit={handleSubmit(onSubmitUpdate)} >

<Box className={'mtb-05rem'} >
  <label>First Name</label>
  <InputComponent
    className="formIcons"
    placeholder={'Enter First Name'}
    name='first_name'
    {...register("first_name")}
    control={control}
    fullWidth
    required
    onChange={handleChangeInput}
    InputProps={{
      startAdornment: (<Box className='inputIcon'
        aria-label="toggle password visibility"
      >
        <PersonOutlineOutlinedIcon sx={{ color: 'action.active', mr: 1, my: 0.5, borderWidth: 1 }} />
      </Box>),
    }}
  />
  {errors?.first_name && <div className='text-errors'>{errors?.first_name}</div>}
</Box>
<Box className={'mtb-05rem'} >
  <label>Last Name</label>
  <InputComponent
    className="formIcons"
    placeholder={'Enter Last Name'}
    name='last_name'
    {...register("last_name")}
    control={control}
    fullWidth
    required
    onChange={handleChangeInput}
    InputProps={{
      startAdornment: (<Box className='inputIcon'
        aria-label="toggle password visibility"
      >
        <PersonOutlineOutlinedIcon sx={{ color: 'action.active', mr: 1, my: 0.5, borderWidth: 1 }} />
      </Box>),
    }}
  />
  {errors?.last_name && <div className='text-errors'>{errors?.last_name}</div>}
</Box>

<Box className={'mtb-05rem'} >
  <label>Mobile Number</label>
  <InputComponent
    className="formIcons"
    placeholder={'Enter Mobile Number'}
    name='mobile'
    {...register("mobile")}
    control={control}
    fullWidth
    required
    onChange={handleChangeInput}
    InputProps={{
      startAdornment: (<Box className='inputIcon'
        aria-label=""
      >
        <PhoneIphoneIcon sx={{ color: 'action.active', mr: 1, my: 0.5, borderWidth: 1 }} />
      </Box>),
    }}
  />
  
</Box>
<Button type="submit" className='form_button btn-theme w-100'>Update</Button>
</form>


              </>

              :
              <> 
              
              

          <div>
            <br />
            {/* <h2>Login with google</h2> */}
            <br />
            {profile && profile?.googleId ? (
                <div>
                    <Typography variant='h6'>Please wait...</Typography>
                    {/* <img src={profile.imageUrl} alt="user image" />
                    <h3>User Logged in</h3>
                    <p>Name: {profile.name}</p>
                    <p>Email Address: {profile.email}</p>
                    <br />
                    <br />
                    <GoogleLogout clientId={clientId} buttonText="Log out" onLogoutSuccess={logOut} /> */}
                </div>
            ) : (
                <>
                <GoogleLogin
                  onSuccess={onSuccess}
                  onError={onFailure}
                />

                {/* <GoogleLogin
                    clientId={clientId}
                    buttonText="Sign in with Google"
                    onSuccess={onSuccess}
                    onFailure={onFailure}
                    cookiePolicy={'single_host_origin'}
                    isSignedIn={true}
                /> */}
                </>
            )}
        </div>
              
              </>
            }
          
          {/* <Button onClick={(e)=>{
            let token = "eyJhbGciOiJSUzI1NiIsImtpZCI6ImQyNWY4ZGJjZjk3ZGM3ZWM0MDFmMDE3MWZiNmU2YmRhOWVkOWU3OTIiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL2FjY291bnRzLmdvb2dsZS5jb20iLCJuYmYiOjE2Nzc1MDE2OTUsImF1ZCI6Ijk1NjkzNjAwODk1MS1sYjljN2lnZW91cmlhNzQ3azFhMTNnZDdqZGQxbWNkbS5hcHBzLmdvb2dsZXVzZXJjb250ZW50LmNvbSIsInN1YiI6IjExMzY4MzY5OTM3MDI3ODI3ODY4NyIsImVtYWlsIjoia3VsZGVlcC5qYXZhaW5pbmRpYUBnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiYXpwIjoiOTU2OTM2MDA4OTUxLWxiOWM3aWdlb3VyaWE3NDdrMWExM2dkN2pkZDFtY2RtLmFwcHMuZ29vZ2xldXNlcmNvbnRlbnQuY29tIiwibmFtZSI6IktVbGRlZXAgS3VtYXIiLCJwaWN0dXJlIjoiaHR0cHM6Ly9saDMuZ29vZ2xldXNlcmNvbnRlbnQuY29tL2EvQUdObXl4WnFmZjVrM0FDY0phY2FTdk83WEdqN19tQlI0NTExbGUxQnRIMFQ9czk2LWMiLCJnaXZlbl9uYW1lIjoiS1VsZGVlcCIsImZhbWlseV9uYW1lIjoiS3VtYXIiLCJpYXQiOjE2Nzc1MDE5OTUsImV4cCI6MTY3NzUwNTU5NSwianRpIjoiMzY0YmE4ZDM3MTExNTY0MzUxYTg2N2I4MWQ5MTVhYzVhN2U5ODZiZSJ9.os1zOBOICEmdNaxhBBAJnM8BRnlJPJb86qlpe1sHztPfOhU7h1H3hAT_1MKw3O72fOGWe-w2a3PgaxvMNlwvS3RMq5flFn6BeUYs6Dg2HMhlbQDvZdula9MKpJlP6pYMdU1iFzq96uO7WhOgu3b89PkoIv7bI8VFBIO4qf8yyV7ter7TBcWdejEX-2Hz6yXego4TpKS0yVyTKbKvdzNUgFmJ-xXwsETMwxRtLCjdkv7i6vqYoeiswCxfYXHoOPyX-OrE8cTGc0hIvBioaBDVY6Wtw9WATqnBBYrSSbtRXKZCuBQQ3CHTfQVPVmif7Gn_rfAMKyzrDYNRtb5WzjmFBA";
            console.log(token)
            var decoded = jwt_decode(token);

            console.log(decoded)
          }}>sasas</Button> */}

        </div>
      </Box>

    </>
  )
}

export default LoginPageUser